import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    redirect: 'nuevo-caso',
  },
  {
    path: '/nuevo-caso',
    name: 'nuevo-caso',
    component: () => import('@/views/NewCaseV2.vue'),
    meta: {
      title: 'SATMED - Registro de Alertas',
    },
  },
  {
    path: '/editar-caso/:id/:token',
    name: 'editar-caso',
    component: () => import('@/views/NewCaseV2.vue'),
    meta: {
      title: 'SATMED - Edición de Alertas',
    },
  },
  {
    path: '/nuevo-caso-old',
    name: 'nuevo-caso-old',
    component: () => import('@/views/NewCase.vue'),
    meta: {
      title: 'SATMED - Registro de Alertas',
    },
  },
  {
    path: '/consultar-caso',
    name: 'consultar-caso',
    component: () => import('@/views/ShowCase.vue'),
    meta: {
      title: 'SATMED - Consulta de Alertas',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'SATMED';
  return next();
});

export default router;
